import React, { useEffect } from "react";
import classNames from "classnames";
import { IOpenMenu } from "../../components/Header/Header.types";
import "./burger.sass";
import { Variants } from "../../configs/configs.types";

export function Burger({ isOpen, openMenuBurger }: IOpenMenu) {
  function handleClick() {
    openMenuBurger(!isOpen);
  }

  const variant = process.env.REACT_APP_VARIANT ?? Variants.v0;

  useEffect(() => {
    const body = document.querySelector("body");
    if (body) {
      isOpen ? body.classList.add("lock") : body.classList.remove("lock");
    }
  }, [isOpen]);

  if (variant === "v1") {
    return (
      <button
        type="button"
        className={classNames("burger-v1", isOpen ? "burger_active" : "")}
        aria-label="Menu"
        onClick={handleClick}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    );
  }

  if (variant === "v2") {
    return (
      <button
        type="button"
        className={classNames("burger", isOpen ? "burger_active" : "")}
        aria-label="Menu"
        onClick={handleClick}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    );
  }

  if (variant === "v3") {
    return (
      <button
        type="button"
        className={classNames("burger", isOpen ? "burger_active" : "")}
        aria-label="Menu"
        onClick={handleClick}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    );
  }
  return (
    <button
      type="button"
      className={classNames("burger", isOpen ? "burger_active" : "")}
      aria-label="Menu"
      onClick={handleClick}
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  );
}
